import { Pipe, PipeTransform } from '@angular/core';
import { IFormatDateArgs, isDefined } from '@fi-shared/utils';
import { FiFormatDateService } from '@fi-shared/fi-format-date/fi-format-date.service';

@Pipe({
    name: 'fiFormatDate',
    standalone: false,
})
export class FiFormatDatePipe implements PipeTransform {
    constructor(private fiFormatDateService: FiFormatDateService) {}

    transform(value: any, format?: Intl.DateTimeFormatOptions | string, args?: IFormatDateArgs): string {
        return this.fiFormatDateService.formatDate(value, format, args);
    }
}
